const EXPORT_CLIENTS = '/sales/clients/account-balance/clients'
const EXPORT_PROVIDERS = '/sales/clients/account-balance/providers'
const CLIENTS_ARCA = '/sales/clients/getClientsArca'
const LIST = '/sales/clients/list'
const SEARCH_CLIENTS = '/sales/clients/searchclients'
const SEARCH_AUTOCOMPLETE = '/sales/clients/search-autocomplete'

const CREATE_CLIENTS = '/sales/clients/create'
const INFO_ONE_CLIENT = '/sales/clients/oneclient'
const BEFORE = '/sales/clients/before'
const CUENTAS = '/sales/clients/cuentas'
const DELETE_CLIENT = '/sales/clients/'
const EDIT_CLIENT = '/sales/clients/edit/'
const CHANGE_STATUS = '/sales/clients/changeStatus'
const DELETE_CONTACT_INFORMATION = '/sales/clients/deletedata/'
const EXPORT_DATA_CLIENTS = '/sales/clients/exportclients'
const PRINT_CTA_CTE = '/sales/clients/printctacte'
const CREATE_FOLLOW_UP_HISTORY = '/sales/clients'

export const salesClientsEndpoints = {
  EXPORT_CLIENTS,
  EXPORT_PROVIDERS,
  CLIENTS_ARCA,
  LIST,
  SEARCH_CLIENTS,
  SEARCH_AUTOCOMPLETE,
  CREATE_CLIENTS,
  INFO_ONE_CLIENT,
  BEFORE,
  CUENTAS,
  DELETE_CLIENT,
  EDIT_CLIENT,
  CHANGE_STATUS,
  DELETE_CONTACT_INFORMATION,
  EXPORT_DATA_CLIENTS,
  PRINT_CTA_CTE,
  CREATE_FOLLOW_UP_HISTORY,
}
